Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    fontBold = _STYLES$useStyles.fontBold,
    COLORS = _STYLES$useStyles.COLORS,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var container = {
    flexBasis: 'auto',
    width: '100%'
  };
  var title = Object.assign({}, fontBold, {
    color: COLORS.aubergine,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    textAlign: 'center',
    marginBottom: spacing.m
  });
  if (bp.is([bp.tablet, bp.desktop])) {
    title.fontSize = _styles.STYLES.fontSize.m;
    title.lineHeight = _styles.STYLES.lineHeight.m;
  }
  var filters = {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '100%'
  };
  var toggle = {
    alignSelf: 'center',
    marginTop: spacing.l
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    title: title,
    filters: filters,
    toggle: toggle
  });
  return {
    styles: styles
  };
};